// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import { api, apiRoutes, apiUrl } from './api'
import { useAuth, auth } from './auth'
import './filters'
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// import './assets/scss/element-variables.scss'
import fontawesome from '@fortawesome/fontawesome'
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
import brands from '@fortawesome/fontawesome-free-brands'
import fasolid from '@fortawesome/fontawesome-free-solid'
import Breadcrumb from './components/shared/breadcrumb/Breadcrumb'
import IconButton from './components/shared/IconButton'
import DGInput from './components/shared/DGInput'
import PageHeader from './components/shared/PageHeader'
import './mobileCheck'

import lang from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'

import * as VueGoogleMaps from 'vue2-google-maps'

import './assets/scss/app.scss'

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyDVQisMkdpnU8YWFD-EQ-flv9DOv5VSO5Q'
  }
})


Vue.use(Element)
locale.use(lang)

fontawesome.library.add(fasolid)
fontawesome.library.add(brands)

Vue.component('fa', FontAwesomeIcon)
Vue.component('breadcrumb', Breadcrumb)
Vue.component('icon-button', IconButton)
Vue.component('dg-input', DGInput)
Vue.component('page-header', PageHeader)

Vue.prototype.$http = api
Vue.prototype.$api = apiRoutes
Vue.prototype.$apiUrl = apiUrl
Vue.prototype.$auth = auth

useAuth()
auth.setUser()

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  data: {
    stationAvailabilityAttributes: {
      public: null,
      hidden: null
    },
    pageTitle: '',
    currency: 'LOADING',
    saldo: 0,
    userOrganizations: [],
    organizationId: null,
    userLocation: {
      loading: true,
      enabled: false,
      lat: 0,
      lng: 0
    }
  },
  computed: {
    geoEnabledAndLoaded () {
      return this.userLocation.enabled && !this.userLocation.loading
    },
    formatSaldo () {
      return this.saldo.base + '.' + this.saldo.decimal
    },
    isMobile () {
      return window.innerWidth < 480
    },
    isSystem () {
      return this.$auth.user.isSystem
    },
    isAdmin () {
      const admin = this.userOrganizations.find(item => item.isOrganizationAdmin && item.organization.id === this.$route.params.orgId)
      return admin !== undefined
    },
    saldoDisplay () {
      let decimalSplit = this.saldo.toString().split('.')
      return {
        base: decimalSplit[0],
        decimal: decimalSplit[1] !== undefined ? decimalSplit[1] : '00'
      }
    }
  },
  methods: {
    updateSaldo (amount) {
      this.saldo = parseFloat(this.saldo) + parseFloat(amount)
    },
    getUserLocation () {
      if (navigator.geolocation) {
        this.userLocation.enabled = true
        navigator.geolocation.getCurrentPosition((position) => {
          this.userLocation.lat = position.coords.latitude
          this.userLocation.lng = position.coords.longitude
          this.userLocation.loading = false
        })
      }
    },
    getUserOrganizations (cb = () => {}) {
      if (this.$auth.isLoggedIn()) {
        this.$http.get(this.$api.user(this.$auth.user.id).organizations)
          .then(response => {
            this.userOrganizations = response.data
            cb()
          }, _ => {
            this.$message.error('Could not load collection')
          })
      }
    }
  },
  created () {
    this.getUserLocation()
    this.organizationId = this.$route.params.orgId
    this.getUserOrganizations()
  }
})



// WEBPACK FOOTER //
// ./src/main.js